<template>
    <div>
        <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
            <div class="container">
                <router-link class="navbar-brand" :to="{ name: 'dashboard' }">WS BPJS</router-link>
                <button class="navbar-toggler d-lg-none" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="collapsibleNavId">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                        <template v-if="isLoggedIn">
                            <li class="nav-item active">
                                <router-link class="nav-link" exact :to="{ name: 'dashboard' }">
                                    Home <span class="sr-only">(current)</span>
                                </router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="dropdownAntrean" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Antrean</a>
                                <div class="dropdown-menu" aria-labelledby="dropdownAntrean">
                                    <router-link class="dropdown-item" :to="{ name: 'antrean.tambahAntrean' }">
                                        Tambah Antrean
                                    </router-link>
                                    <router-link class="dropdown-item" :to="{ name: 'antrean.updateWaktuAntrean' }">
                                        Update Waktu Antrean
                                    </router-link>
                                    <router-link class="dropdown-item" :to="{ name: 'antrean.batalantrean' }">
                                        Batal Antrean
                                    </router-link>
                                    <router-link class="dropdown-item" :to="{ name: 'antrean.getlisttaskid' }">
                                        List Task Id
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="dropdownId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Referensi</a>
                                <div class="dropdown-menu" aria-labelledby="dropdownId">
                                    <router-link class="dropdown-item" :to="{ name: 'referensi.poli' }">
                                        Poli
                                    </router-link>
                                    <router-link class="dropdown-item" :to="{ name: 'referensi.dokter' }">
                                        Dokter
                                    </router-link>
                                    <router-link class="dropdown-item" :to="{ name: 'referensi.jadwalDokter' }">
                                        Jadwal Dokter
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link btn-logout" @click="logout">Logout</a>
                            </li>
                        </template>
                        <template v-else>
                            <li class="nav-item active">
                                <router-link class="nav-link" :to="{ name: 'auth.login' }">
                                    Login
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </nav>

        <!-- content -->
        <div class="my-3">
            <div class="container-fluid">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                user: 'user',
            })
        },
        methods: {
            logout() {
                let conf = window.confirm("Are you sure !");
                if (conf == true) {
                    this.$store.dispatch("logout").then(() => {
                        this.$router.push('/dashboard')
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
    .btn-logout {
        cursor: pointer;
    }
</style>
